import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LogDetailsModalComponent } from 'src/app/shared/components/log-details-modal/log-details-modal.component';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { RequestLogService } from 'src/app/shared/services/API/srv-message-queue/request-log.service';
import { MessageQueueModel } from 'src/app/shared/services/models/srv-message-queue/button-type.model';

@Component({
  selector: 'app-log-message-queue',
  templateUrl: './log-message-queue.component.html',
  styleUrls: ['./log-message-queue.component.css']
})
export class LogMessageQueueComponent implements OnInit {
  constructor(private alertService: AlertService,
    public dialog: MatDialog,
    private requestLogService: RequestLogService,
  ) { }
  
  @ViewChild(MatPaginator) paginator: MatPaginator;

  menuModuleEnum: MenuModuleEnum = MenuModuleEnum.developer;
  menuFunctionalityEnum: MenuFunctionalityEnum = MenuFunctionalityEnum.log_batch_list;

  isLoading: boolean = true;
  searchText: string = null;
  listLog: any[] = null;
  listIdHealthUnit: number[] = [];
  listMessageType: string[] = [];

  messageType: string = null;
  idHealthUnit: number = null;
  fullListSize: number = 0;
  listMessageQueue: MessageQueueModel[] = [];

  selectedPeriod: Date = null;

  columns: { header: string, field: string, isAction?: boolean, width?: string }[] = [
    { header: 'Tipo de mensagem', field: 'messageType', width: '13%' },
    { header: 'Data de inclusão', field: 'datetimeInclusion', width: '10%' },
    { header: 'ID Unidade de Saúde', field: 'idHealthUnit', width: '10%' },
    { header: 'Log', field: 'message', width: '30%' },
    { header: 'Ações', field: 'actions', isAction: true, width: '2%' }
  ];

  ngOnInit(): void {
    this.search(0);
  }

  changePage(event: PageEvent) {
    this.search(event.pageIndex);
  }

  private timeoutKeySearch: any = null;

  onKeySearch(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13)
        $this.search(0);
    }, 1000);
  }

  search(pageIndex: number) {
    this.isLoading = true;
    this.listLog = null;

    if (this.selectedPeriod instanceof Date)
      this.selectedPeriod.setHours(0, 0, 0, 0);

    this.requestLogService.search(this.selectedPeriod, pageIndex, this.searchText, this.messageType, this.idHealthUnit).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        if (response?.listMessageQueue?.length > 0) {
          this.listMessageType = response.listMessageType;

          this.listIdHealthUnit = response.listIdHealthUnit;

          this.fullListSize = response.fullListSize;
          this.listLog = this.transformToTableRows(response.listMessageQueue);
        }
        else {
          if (!this.idHealthUnit)
            this.listIdHealthUnit = null;
          if (!this.messageType)
            this.listMessageType = null;

          this.listMessageQueue = null;
          this.listLog = null;
          this.fullListSize = 0;
        }

        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  cancel() {
    this.searchText = null;
    this.selectedPeriod = null;
    this.idHealthUnit = null;
    this.messageType = null;
    this.search(0);
  }

  logDetails(event: any) {
    let numberOfLinesInTextPatientExitLog = this.countLinesInArea(event.message, 825, 16);
    const dialogRef = this.dialog.open(LogDetailsModalComponent, {
      panelClass: 'custom-dialog-class',
      height: '90vh',
      disableClose: true,
      data: {
        logRequestDetails: event.message,
        numberOfLinesInTextPatientExitLog
      }
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
      }
    });
  }

  countLinesInArea(text: string, areaWidth: number, fontSize: number): number {
    if (!text || text.trim() === "")
      return 0;

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) return 0;

    context.font = `${fontSize}px Arial`;

    const words = text.split(' ');
    let lineWidth = 0;
    let lines = 1;

    for (const word of words) {
      const wordWidth = context.measureText(word + ' ').width;
      if (lineWidth + wordWidth > areaWidth) {
        lines++;
        lineWidth = wordWidth; // Começa uma nova linha
      }
      else
        lineWidth += wordWidth;
    }

    return lines;
  }

  transformToTableRows(listLog: MessageQueueModel[]) {
    return listLog.map(log => {
      const handleInvalidJson = (jsonString: string): any => {
        if (jsonString.startsWith("INVALID_JSON: "))
          return jsonString.replace("INVALID_JSON: ", ""); // Remove a marcação e exibe como string

        try {
          return JSON.parse(jsonString);
        }
        catch {
          return jsonString; // Se ainda assim der erro, exibe como string
        }
      };

      let logRequest = handleInvalidJson(log.message || "{}");
      let formattedLogData = this.beautify(logRequest);

      return {
        messageType: log.idMessageType,
        datetimeInclusion: log.datetimeInclusion,
        idHealthUnit: log.idHealthUnit,
        message: formattedLogData,
      };
    });
  }

  beautify(json: any): string {
    return typeof json === "string" ? json : JSON.stringify(json, null, 2);
  }
}